export const clickOnCruiseRoute = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'read_more_cruise_route',
    });
  }
};
